import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
interface CTAButtonProps {
  mainText: string;
  subText?: string;
  className?: string;
  large?: boolean;
  isCheckout?: boolean;
}
export function CTAButton({
  mainText,
  subText,
  className = '',
  large = false,
  isCheckout = false
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={() => {
    if (isCheckout) {
      trackAddToCart();
      window.open('https://godeskcore.com/cart/42911548178480:1', '_blank');
    } else {
      const el = document.getElementById('pricing');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }} className={`group flex flex-col items-center justify-center w-full max-w-md mx-auto bg-gold hover:bg-gold-hover text-white rounded-xl shadow-gold-glow transition-colors duration-300 ${large ? 'py-5 px-8' : 'py-4 px-6'} ${className}`} data-id="element-34">
      <div className="flex items-center gap-2" data-id="element-35">
        <Check className="w-5 h-5 md:w-6 md:h-6" strokeWidth={2.5} data-id="element-36" />
        <span className={`font-bold tracking-wide ${large ? 'text-lg md:text-xl' : 'text-base md:text-lg'}`} data-id="element-37">
          {mainText}
        </span>
      </div>
      {subText && <span className="text-white/90 text-sm md:text-base mt-1 font-medium text-center" data-id="element-38">
          {subText}
        </span>}
    </motion.button>;
}